import {
    CLEAR_ALL,
    CLEAR_CRUD_EVENT,
    DELETE_EVENT_SUCCESS,
    GET_CRUD_EVENT_REQUEST,
    GET_CRUD_EVENT_SUCCESS,
    GET_CRUD_EVENT_ERROR,
    GET_CUSTOM_EVENT_TYPE_PARAMS_SUCCESS,
    GET_CUSTOM_EVENT_TYPE_PARAMS_ERROR,
    GET_CUSTOM_EVENTS_REQUEST,
    GET_CUSTOM_EVENTS_SUCCESS,
    GET_CUSTOM_EVENTS_ERROR,
} from 'constants/ActionTypes';

const initialState = {
    list: [],
    listLoading: false,
    listError: false,
    typeParams: [],
    crudEvent: null,
    crudEventLoading: false,
    crudEventError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CUSTOM_EVENTS_REQUEST:
            return {
                ...state,
                listLoading: true,
            };

        case GET_CUSTOM_EVENTS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                listLoading: false,
            };

        case GET_CUSTOM_EVENTS_ERROR:
            return {
                ...state,
                list: null,
                listLoading: false,
            };

        case GET_CUSTOM_EVENT_TYPE_PARAMS_SUCCESS:
            return {
                ...state,
                typeParams: action.payload,
            };

        case GET_CUSTOM_EVENT_TYPE_PARAMS_ERROR:
            return {
                ...state,
                typeParams: [],
            };

        case GET_CRUD_EVENT_REQUEST:
            return {
                ...state,
                crudEvent: null,
                crudEventLoading: true,
                crudEventError: false,
            };

        case GET_CRUD_EVENT_SUCCESS:
            return {
                ...state,
                crudEvent: action.payload,
                crudEventLoading: false,
                crudEventError: false,
            };

        case GET_CRUD_EVENT_ERROR:
            return {
                ...state,
                crudEvent: null,
                crudEventLoading: true,
                crudEventError: true,
            };

        case DELETE_EVENT_SUCCESS: {
            const name = action.payload;
            const index = state.list.findIndex((event) => event.name === name);
            if (index > -1) {
                state.list.splice(index, 1);
            }
            return {
                ...state,
            };
        }

        case CLEAR_CRUD_EVENT:
            return {
                ...state,
                crudEvent: null,
            };

        case CLEAR_ALL:
            return initialState;

        default:
            return {
                ...state,
            };
    }
}
